import React, { useState, useEffect } from 'react';

import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  OptionalFeatureBase,
} from "@models";
import { 
  Character,
  CharacterFeatureBase,
  CharacterFeatureSource,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../../utilities/common_utilities';

import CharacterFeatureBaseOptionsInput from "@dndComponents/character/features/CharacterFeatureBaseOptions";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LoadingBox from "@components/input/LoadingBox";

import CenteredMenu from "@components/input/menus/CenteredMenu";
import CharacterFeatureBasesInput from "@dndComponents/character/features/CharacterFeatureBasesInput";

interface Props {
  char: Character;
  sources: CharacterFeatureSource[];
  log_it?: boolean;
  load_optionals_time?: number;
  // onChange: (do_main: boolean) => void;
  onCFSSelect?: (selected: CharacterFeatureSource | undefined) => void;
  onCFBSelect?: (selected: CharacterFeatureBase | undefined) => void;
  extra_cfs_header_control?: (cfs: CharacterFeatureSource) => React.ReactNode;
  extra_cfs_controls?: (cfs: CharacterFeatureSource) => React.ReactNode[];
  extra_bottom_controls?: () => React.ReactNode[];
  cfs_sort?: (a: CharacterFeatureSource, b: CharacterFeatureSource) => number;
  change_time: number;
  expanded_cfs_id: string;
  expanded_cfb_id: string;
  show_cfb_levels?: boolean;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterFeatureSourcesInput({
  char,
  sources,
  log_it = false,
  load_optionals_time = 0,
  // onChange,
  onCFSSelect,
  onCFBSelect,
  extra_cfs_header_control,
  extra_cfs_controls,
  extra_bottom_controls,
  cfs_sort,
  change_time,
  expanded_cfs_id,
  expanded_cfb_id,
  show_cfb_levels = false
}: Props) {
  const [show_features, setShowFeatures] = useState(true);
  const [view, setView] = useState("Current");
  const [optional_feature_bases, setOptionalFeatureBases] = useState<OptionalFeatureBase[]>([]);
  const [my_expanded_cfs_id, setExpandedCFSID] = useState("");

  const source = my_expanded_cfs_id !== "" ? 
    sources.find(o => o.true_id === my_expanded_cfs_id) : 
    (expanded_cfs_id !== "" ? 
      sources.find(o => o.true_id === expanded_cfs_id) : 
      (sources.length === 1 ? sources[0] : undefined));

  const load = async (cfs_id = "") => {
    // console.log(cfs_id);
    const use_source = cfs_id !== "" ? 
      sources.find(o => o.true_id === cfs_id) : 
      source;
    if (use_source) {
      // console.log(source);
      // console.log(char_util.optional_feature_bases);
      // console.log(char_util.my_smart_hash);
      if (log_it) { 
        debugger;
      }
      setOptionalFeatureBases(await char_util.get_optional_features(use_source, log_it));
    }
  }

  const renderCharFeatureBases = () => {
    if (source) {
      console.log(source);
      // const combined_features = char_util.useFeatures2(character, source, true); // , log_it
      // const char_feature_bases = combined_features.sort((a, b) => (a.feature_base && b.feature_base && a.feature_base.level > b.feature_base.level) ? 1 : -1);
      // const cfbs_by_level = getCharFeatureBasesForRender(char_feature_bases);
      // console.log(cfbs_by_level);
      if (log_it) {
        // console.log(source);
        // console.log(char_feature_bases);
        // console.log(char_feature_bases.map(o => o.level));
        // console.log(cfbs_by_level);
      }
      // const sort_levels = Object.keys(cfbs_by_level).map(o => +o); // .sort();
      const colors = char_util.getColors({ char: char, user: api.user, for_id: source.source_id });
      return (
        <Grid
          container
          spacing={0}
          direction="row"
          size={{
            xs: 12
          }}>
          { extra_cfs_controls && extra_cfs_controls(source) }
          <Grid
            size={{
              xs: 12
            }}>
            <ToggleButtonBox 
              name={ show_features ? "Hide Features" : "Show Features" }
              value={show_features}
              matchButtonBox
              colors={colors}
              onToggle={() => {
                setShowFeatures(!show_features);
              }}
            />
          </Grid>
          { show_features && 
            <>
              <Grid
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <CenteredMenu 
                    selected={view}
                    options={["Current","Optional"]} 
                    onSelect={setView}                      
                  />
                </Grid>
              </Grid>
              { view === "Current" ?
                <>
                  <CharacterFeatureBasesInput
                    character={char}
                    source={source}
                    log_it={log_it}
                    expanded_cfb_id={expanded_cfb_id}
                    show_cfb_levels={show_cfb_levels}
                    onCFBSelect={onCFBSelect}
                  />
                  {/* { sort_levels.map(sort_level => {
                    const cfbs_by_source = cfbs_by_level[sort_level];
                    const source_true_ids = Object.keys(cfbs_by_source);
                    return (
                      <Grid item xs={12} key={sort_level}>
                        <Grid container spacing={0} direction="row">
                          { show_cfb_levels &&
                            <Grid item xs={12} className="header gray">Level { sort_level }</Grid>
                          }
                          { source_true_ids.sort((a, b) => {
                            const cfsa = cfbs_by_source[a].cfs;
                            const cfsb = cfbs_by_source[b].cfs;
                            if (cfsa.ancestries.length === cfsb.ancestries.length) {
                              return cfsa.name.localeCompare(cfsb.name);
                            } else {
                              return (+cfsa.ancestries.length < +cfsb.ancestries.length ? -1 : 1);
                            }
                          }).map(source_true_id => {
                            const entry = cfbs_by_source[source_true_id];
                            return (
                              <Grid item xs={12} key={source_true_id}>
                                { source && source.true_id !== source_true_id && 
                                  <Grid item xs={12} className="header gray">{ entry.cfs.name }</Grid>
                                }
                                { entry.cfbs.map(cfb => {
                                  if (cfb.name.includes("Ability Score Increase")) {
                                    console.log(cfb);
                                  }
                                  // Making it so if show_cfb_levels then put Labels at the start of each level difference
                                  // if (cfb.true_id === expanded_cfb_id) {
                                  //   console.log(cfb);
                                  // }
                                  return (
                                    <Grid item xs={12} key={cfb.true_id}>
                                      <CharacterFeatureBaseInput
                                        character={character}
                                        source={ entry.cfs }
                                        obj={cfb}
                                        onSelect={() => { 
                                          if (onCFBSelect) {
                                            onCFBSelect(cfb);
                                          }
                                        }}
                                        selected={cfb.true_id === expanded_cfb_id}
                                      />
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>
                    );
                  })} */}
                </>
              : 
                <>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <CharacterFeatureBaseOptionsInput 
                      character={char}
                      char_feature_source={source}
                      optional_feature_bases={ optional_feature_bases }
                      onChange={(_id: string, value: boolean) => {
                        // TODO: Make it work for upgrading feature bases.  
                        // It works similar to replacing
                        if (value) {
                          char.optional_feature_base_ids.push(_id);
                        } else {
                          char.optional_feature_base_ids = char.optional_feature_base_ids.filter(o => o !== _id);
                        }
                        char.changed();
                        char_util.repopulateCharFeatureBases(char);
                      }}
                    />
                  </Grid>
                </>
              }
            </>
          }
        </Grid>
      );
    }
    return null;
  }
  const sorter = (a: any, b: any) => {
    if (cfs_sort) {
      const sort_value = cfs_sort(a, b);
      if (sort_value !== 0) {
        return sort_value;
      }
    }
    if (a instanceof CharacterFeatureSource && b instanceof CharacterFeatureSource) {
      return a.name.trim().localeCompare(b.name.trim());
    } 
    return 1;
  }

  // debugger;
  if (sources.length > 1) {
    return (
      <Grid container spacing={0} direction="row">
        { sources.sort(sorter).map(cfs => {
          return (
            <Grid
              key={cfs.true_id}
              size={{
                xs: 12
              }}>
              <Accordion expanded={my_expanded_cfs_id === cfs.true_id || expanded_cfs_id === cfs.true_id} onChange={() => {  
                // console.log(cfs.true_id);
                if (onCFSSelect) {
                  onCFSSelect(expanded_cfs_id === cfs.true_id ? undefined : cfs);
                } else {
                  const new_cfs_id = my_expanded_cfs_id === cfs.true_id ? "" : cfs.true_id;
                  // load(new_cfs_id);
                  setExpandedCFSID(new_cfs_id);
                }
              }}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography sx={{ width: '33%', flexShrink: 0 }}>
                    { cfs.get_use_name() }
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={0} direction="row">
                    { extra_cfs_header_control && 
                      <Grid
                        size={{
                          xs: 12
                        }}>
                        { extra_cfs_header_control(cfs) }
                      </Grid>
                    }
                    { renderCharFeatureBases() }
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          );
        })}
        { extra_bottom_controls && extra_bottom_controls() }
      </Grid>
    );
  } else if (sources.length === 1 && source) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header"
          size={{
            xs: 12
          }}>
          { source.get_use_name() }&nbsp;{ extra_cfs_header_control && extra_cfs_header_control(source) }
        </Grid>
        { renderCharFeatureBases() }
        { extra_bottom_controls && extra_bottom_controls() }
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={0} direction="row">
        { extra_bottom_controls && extra_bottom_controls() }
      </Grid>
    );
  }
}
